module.exports = __webpack_public_path__ + "static/media/Zvonimir.204ef10a.jpg";